import Swiper from "swiper/bundle";

export default () => {
    new Swiper(".blog-slider", {
        slidesPerView: 3,
        breakpoints: {
            320: {
                slidesPerView: 1.1
            },
            // when window width is >= 320px
            576: {
                slidesPerView: 1.4
            },
            // when window width is >= 480px
            767: {
                slidesPerView: 2.1
            },
            991: {
                slidesPerView: 2.6
            },
            // when window width is >= 640px
            1199: {
                slidesPerView: 3
            }
        }
    });
    
    new Swiper(".mySwiper", {
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    new Swiper(".yoga-swiper", {
        slidesPerView: 1.1,
        pagination: {
            el: ".pagination",
            clickable: true,
        },
    });
}
